import { Injectable } from '@angular/core';
import {Horaire} from "@models/horaire.model";
import {HoraireJourInterface} from "@interfaces/horaireJour.interface";

@Injectable({
    providedIn: 'root'
})
export class HoraireService {
    constructor() {}

    public getDayInHorairesListWithCodeDay(horaires: Horaire[], codeJour: number): Horaire {
        return horaires.find(element => element.code_jour === codeJour);
    }

    public transformHoraireJourInHoraire(code: number, nom: string, jour: HoraireJourInterface): Horaire {
        return new Horaire({
            code_jour: code,
            nom_jour: nom,
            horaire_ouverture_matin: jour.matin.ouverture,
            horaire_fermeture_matin: jour.matin.fermeture,
            horaire_ouverture_apm: jour.apMidi.ouverture,
            horaire_fermeture_apm: jour.apMidi.fermeture,
        });
    }
}
